import React, { useState, useContext, useEffect } from 'react'
import CloudformationOutputs from '../CloudformationOutputs.json'
import { GlobalContext } from '../GlobalContext'

type Props = {
  
}


function SingleSignOn({
}: Props) {

    const {
        t
    } = useContext(GlobalContext)


    const [showMe, setShowMe] = useState(false)
    const client_id = CloudformationOutputs['EntraClientId']
    const redirect_url_raw = CloudformationOutputs['EntraRedirectLambdaUrl']
    const redirect_url = encodeURIComponent(redirect_url_raw)
    const currentUrlOrigin = window.location.origin
    const entraUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${client_id}&response_type=code&redirect_uri=${redirect_url}&scope=openid%20profile%20email&state=${currentUrlOrigin}`

    useEffect(() => {
      const handleKeyDown = (e: KeyboardEvent) => {
        if (e.ctrlKey && e.shiftKey && e.key === 'S') {
          e.preventDefault()
          setShowMe((prev) => !prev)
          localStorage.setItem('showSSO', JSON.stringify(!showMe))
        }
      }
      window.addEventListener('keydown', handleKeyDown)
      const showSSOFromLocalStorage = localStorage.getItem('showSSO')
      const showSSOFromQueryString = new URLSearchParams(window.location.search).get('showSSO')
      if (showSSOFromLocalStorage && (showSSOFromLocalStorage === 'true' || showSSOFromLocalStorage === 'false')) {
        setShowMe(JSON.parse(showSSOFromLocalStorage))
      }
      if (showSSOFromQueryString && (showSSOFromQueryString === 'true' || showSSOFromQueryString === 'false')) {
        setShowMe(showSSOFromQueryString === 'true')
        localStorage.setItem('showSSO', showSSOFromQueryString)
      }
  
      return () => {
        window.removeEventListener('keydown', handleKeyDown)
      }
    }, [showMe])


    return <div className={` ${showMe? 'w-full flex flex-col gap-2' : 'hidden'}`}> 

        <a href={entraUrl} className={`w-full px-3 py-3 bg-white flex flex-row gap-4 items-center justify-center cursor-pointer hover:opacity-80 text-gray-800 border-gray-400 rounded`}>
            <img src={`/logos/microsoft.svg`} alt={`Microsoft logo`} className={`w-6 h-6`} />
            {t('Auth.SingleSignOn.logInWithMicrosoft')}
        </a>

    </div>
}
export default SingleSignOn